const KEY = "mic-device-id";

export const getMicId = () => localStorage.getItem(KEY) || "";
export const setMicId = (id) => (id ? localStorage.setItem(KEY, id) : localStorage.removeItem(KEY));

export const micConstraints = (deviceId = getMicId()) => ({
  audio: { ...(deviceId ? { deviceId: { ideal: deviceId } } : {}), echoCancellation: true, noiseSuppression: true, autoGainControl: true },
});

export const SPEECH_LEVEL = 0.012;

// Live RMS level (0-1) of a stream; call close() when done.
export const createMeter = (stream) => {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  ctx.resume().catch(() => {});
  const src = ctx.createMediaStreamSource(stream);
  const an = ctx.createAnalyser();
  an.fftSize = 1024;
  src.connect(an);
  const buf = new Float32Array(an.fftSize);
  return {
    read: () => { an.getFloatTimeDomainData(buf); return Math.sqrt(buf.reduce((a, v) => a + v * v, 0) / buf.length); },
    close: () => { src.disconnect(); ctx.close().catch(() => {}); },
  };
};

export const pickMime = () => ["audio/webm;codecs=opus", "audio/webm", "audio/mp4"].find((t) => window.MediaRecorder?.isTypeSupported?.(t));
